import React, { FC } from 'react';

import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRefresh,
} from 'react-admin';

import { useTitle } from '@src/hooks';

import PluginEditActions from './PluginEditActions';
import PluginEditToolbar from './PluginEditToolbar';

interface IPluginEditProps {
  label: string;
}

const PluginEdit: FC<IPluginEditProps> = ({ label }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const { title } = useTitle(`Update ${label}`);
  return (
    <Edit
      actions={<PluginEditActions />}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Configuration file updated successfully', { type: 'success' });
          refresh();
        },
        onError: (error) => {
          if (error instanceof Error) {
            notify(`Error updating configuration file: ${error.message}`, { type: 'error' });
          } else {
            notify('Error updating configuration file', { type: 'error' });
          }
        },
      }}
      title={title}
    >
      <SimpleForm
        toolbar={<PluginEditToolbar />}
      >
        <TextInput
          label="Config version name"
          source="configVersion.name"
          validate={[required()]}
        />
        <TextInput
          label="Plugin settings"
          fullWidth
          multiline
          rows={30}
          source="settings"
          validate={[required()]}
        />
      </SimpleForm>
    </Edit>
  );
};

export default PluginEdit;